import { ComponentsOverrides, Theme } from "@mui/material";

type MuiCardActions = {
  styleOverrides: ComponentsOverrides<Theme>["MuiCardActions"];
};

const muiCardActions: MuiCardActions = {
  styleOverrides: {
    root: {
      padding: "0 24px 24px",
    },
  },
};

export default muiCardActions;
